<template>
  <button
    type="button"
    class="back-button-with-border"
    aria-label="戻る"
    @click="$emit('back')"
  >
    <img
      :src="require(`@/assets/img/icon/svg/button-back-with-border.svg`)"
      class="back-button-with-border__icon"
      alt=""
    />
  </button>
</template>

<script>
/**
 * 枠線付きの戻るボタン。
 */
export default {
  name: "BackButtonWithBorder",
  emits: ["back"],
};
</script>

<style lang="scss" scoped>
$size: 24px;
.back-button-with-border {
  display: flex;
  width: $size;
  height: $size;
  padding: 0;
  margin: 0;
  border: none;
  background-color: transparent;
  appearance: none;
  -webkit-appearance: none;
  cursor: pointer;
}
</style>
